export const isViewPortMobile = (width: number): boolean => {
  return width <= 768
}
